import { createContext, useContext } from "react";

import { PlayerUpdateEvent } from "../types/public";

interface PlayerContext {
  update: PlayerUpdateEvent;
}

export const PlayerContext = createContext<PlayerContext | undefined>(
  undefined
);

export const usePlayerContext = (): PlayerContext => {
  const context = useContext(PlayerContext);
  if (context === undefined) {
    throw new Error("PlayerContext not found");
  }
  return context;
};
